import React from 'react'
import Footer from '../../../components/Footer'
import ScienceImg from "../../../assets/images/science.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';
const BSCPCM = () => {
  return (
    <div className='  w-full relative font-poppins ' >
        <Title canonicalPath="/programmes/ug-courses/sciences/bsc/physics-chemistry-maths" />
        <Title title="B.Sc. in Physics, Chemistry, and Maths at MDU" description="Pursue B.Sc. in Physics, Chemistry, and Maths at Maya Devi University, Dehradun. Build a strong foundation for a career in scientific research and development." />
        <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
        <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>B.Sc. Physics- Chemistry- Maths (PCM)</h2>
        <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
            <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[60px] mt-5 justify-center md:justify-between ' >
                <img src={ScienceImg} className=' md:w-[40%] rounded-lg ' alt='Student in a bio lab'/>
                <div className=' flex flex-col gap-4 ' >
                    <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
                    <p className=' text-justify md:text-md ' >Bachelor of Science (B.Sc.) in Physics, Chemistry and Mathematics (B.Sc. in PCM) is a regular degree program which deals with the field of science and is designed to emphasize the fundamentals of the basic sciences. The duration of the course is four years which consists of eight semesters under the New Education Policy 2020. It includes 2-year (diploma), 3-year (degree) and 4-year (research / honours) exit options. The curriculum is devised to inculcate research culture and environmental awareness amongst the students.
<br/><br/>
Therefore, all the three subjects in B.Sc. PCM are combined and taught in detail. In Physics, students conduct experiments, analyze data, and make scientific observations firsthand. Under chemistry, candidates learn about the science of substance in a more precise manner. The Mathematics branch of the course equips students with strong analytical and problem-solving skills that are essential in various fields including science, engineering, finance, and technology Students are also involved in in-house projects gaining exposure in the research field. Consequently, along with the underlying hypothetical understanding, the students are exposed to realistic aspects through the vibrant laboratory sessions.</p>
                    <Link to="https://admission.maya.edu.in/" >
                    <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                    >Register Now</button>
                </Link>
                </div>
            </div>

            <div className=' flex flex-col gap-10 mt-5 mb-[20px] ' >
               <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>Intermediate / 10+2 or its equivalent examination with PCM (Physics, Chemistry, Maths) from a recognized Board/ University/ MDU Entrance Examination</p>
                    </div>
                    </div>

            <h4 className={` text-2xl font-semibold text-[#23376c] `}>B.Sc –(HONORS AND RESEARCH) in Physics</h4>

            <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                        <ul className=' list-disc ' >
                        <li>Get acquainted with techniques which are useful in industry.</li>
                        <li>Get conceptual knowledge of entrepreneurship through co-curricular activities.</li>
                        <li>Learn organizational skills and working in groups.</li>
                        <li>Develop the ability to solve complex problems by the application of computers.</li>
                        </ul>
               </div>

            <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                        <ul className=' list-disc ' >
                        <li>B.Sc graduates with Physics have a broad choice of employment opportunities in various sectors like educational institutes,research firms,testing laboratories, Industries, and the list continues.</li>
                        <li>With B.Sc degree in physics there are various options available for  students, they can go for master degree in Physics or  can even look for professional job oriented courses.</li>
                        <li>Apart from the research jobs, students can also work or get jobs in Marketing, Business & Other technical fields. Science graduates were also recruited in the bank sector to work as customer service executives. Students can also find employment in government sectors.</li>
                        </ul>
               </div>

               <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                        <ul className=' list-disc ' >
                        <li>Research Analyst</li>
                        <li>Radiologist</li>
                        <li>Geophysicist</li>
                        <li>Metallurgist</li>
                        <li>Nanotechnologist</li>
                        <li>Data Analyst</li>
                        <li>Laboratory Analyst</li>
                        </ul>
               </div>

               <h4 className={` text-2xl font-semibold text-[#23376c] mt-[20px] `}>B.Sc. –(HONORS AND RESEARCH) IN CHEMISTRY</h4>

            <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                        <ul className=' list-disc ' >
                        <li>Develop research-based knowledge.</li>
                        <li>Employ critical thinking and scientific knowledge to design, carry out, record, and analyze the results of chemical reactions.</li>
                        <li>Create an awareness of the impact of chemistry on the environment, society, and development outside the scientific community.</li>
                        <li>Find out the green route for chemical reaction for sustainable development.</li>
                        <li>Inculcate the scientific temperament in the students and outside the scientific community.</li>
                        </ul>
               </div>

            <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                        <ul className=' list-disc ' >
                        <li>After BSc in chemistry one can enter multiple domains like in academic or industrial research laboratories, where they conduct experiments, analyze data, develop new compounds or materials, and contribute to scientific discoveries. Chemistry graduates can also work in government agencies, environmental consulting firms, or research organizations, conducting research, analyzing samples, and developing strategies for environmental preservation and remediation.</li>
                        </ul>
               </div>

               <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                        <ul className=' list-disc ' >
                        <li>Chemical Industries</li>
                        <li>Analytical Chemist</li>
                        <li>Pharmaceutical and Biotechnology Industry</li>
                        <li>Environmental Science</li>
                        <li>Education</li>
                        <li>Forensic Science</li>
                        <li>Materials Science</li>
                        <li>Scientific Journalism and Technical Writing</li>
                        </ul>
               </div>

                <h4 className={` text-2xl font-semibold text-[#23376c] mt-[20px] `}>BSc MATHEMATICS</h4>

                <div className=' flex flex-col gap-2 ' >
                            <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                            <ul className=' list-disc ' >
                            <li>Communicate mathematics effectively by written, computational, and graphic means.</li>
                            <li>Create mathematical ideas from basic axioms.</li>
                            <li>Gauge the hypothesis, theories, techniques, and proofs provisionally.</li>
                            <li>Utilize mathematics to solve theoretical and applied problems by critical understanding, analysis, and synthesis.</li>
                            <li>Identify applications of mathematics in other disciplines and in the real world, leading to enhancement of career prospects in a plethora of fields and research.</li>
                            </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                            <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                            <ul className=' list-disc ' >
                            <li><strong>Actuarial Science:</strong> Actuaries evaluate financial risks in insurance, finance, and other industries using mathematical and statistical models to analyze data and help organizations manage risk.</li>
                            <li><strong>Data Analysis/Data Science:</strong> With the emergence of big data, there’s a growing demand for professionals who can analyze and interpret large datasets.</li>
                            <li><strong>Software Development/Programming:</strong> Mathematics graduates often excel in programming roles, especially in fields such as algorithm development, software engineering, and computer science.</li>
                            <li><strong>Teaching and Academia:</strong> Many Mathematics graduates pursue careers in education, working as teachers at various levels or pursuing advanced degrees to become professors and researchers in academia.</li>
                            <li><strong>Engineering:</strong> Mathematics is fundamental to engineering disciplines such as mechanical engineering, civil engineering, and electrical engineering.</li>
                            </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                            <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                            <ul className=' list-disc ' >
                            <li>Data Analyst/Data Scientist</li>
                            <li>Statistician</li>
                            <li>Mathematician</li>
                            <li>Financial Analyst</li>
                            <li>Quantitative Analyst</li>
                            <li>Teaching/Academia</li>
                            </ul>
                </div>

                <div className=' flex flex-col gap-2 mt-[20px] mb-[30px] ' >
                            <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>USPs</h4>
                            <ul className=' list-disc ' >
                            <li>Energetic and dedicated faculty members in many diverse areas.</li>
                            <li>Centre of Excellence in Specific Domain & Technology for Experiential Learning.</li>
                            <li>Advance Course Curriculum designed by distinguished Academia.</li>
                            <li>Choice Based Credit System (CBCS) and Outcome based teaching, assessments, and evaluation.</li>
                            <li>Dissertation after 3rd Year to give exposure to the scientific field.</li>
                            <li>Advance Diagnostic & Mentoring for Career and Placement throughout the Course.</li>
                            <li>Dynamic Programming & Core Skill Guidance throughout the course.</li>
                            <li>Start-up & Idea Innovation Lab for Career & Professional Growth.</li>
                            </ul>
                </div>

            {/* table */} 
            <div className="flex flex-col mb-[100px] ">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-center text-sm font-light">
                        <thead
                            className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                            <tr>
                            <th scope="col" className=" px-6 py-4">Programme</th>
                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Science</td>
                            <td className="whitespace-nowrap  px-6 py-4">Bachelor of Science (B.Sc.) in <br/> Physics, Chemistry and Mathematics (B.Sc. in PCM)</td>
                            <td className="whitespace-nowrap  px-6 py-4">3</td>
                            <td className="whitespace-nowrap  px-6 py-4">25</td>
                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                </div>

        </div>
        <Footer/>
    </div>
  )
}


export default BSCPCM